/**
 * PATH: apps/inventory/src/pages/LocationsPage.tsx
 * PURPOSE: Warehouse and location management
 */
import { EmptyRegister } from './emptyRegister'

export default function LocationsPage() {
  return (
    <EmptyRegister
      title="Locations"
      detail="No warehouses or storage locations are connected."
    />
  )
}
